import type { ReactNode } from 'react';
import ScrollReveal from '@/components/common/ScrollReveal';

interface SectionTitleProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Small sparkle before the title, as on highlighted sections. */
  sparkle?: boolean;
  className?: string;
}

/** Centered section heading used by every landing section. */
export default function SectionTitle({ title, subtitle, sparkle = false, className = '' }: SectionTitleProps) {
  return (
    <ScrollReveal animation="fade-up" className={`text-center max-w-2xl mx-auto mb-10 md:mb-12 ${className}`}>
      <h2 className="inline-flex items-center gap-2 text-2xl md:text-[34px] md:leading-tight font-bold text-[#1f2329] tracking-tight">
        {sparkle && (
          <i className="ri-sparkling-2-fill text-2xl bg-gradient-to-br from-[#2f6bff] to-[#c25cff] bg-clip-text text-transparent" />
        )}
        {title}
      </h2>
      {subtitle && <p className="mt-3 text-sm md:text-base text-[#646a73]">{subtitle}</p>}
    </ScrollReveal>
  );
}
